module.exports = {"130434100":"魏城镇","130434101":"德政镇","130434102":"北皋镇","130434103":"双井镇","130434104":"牙里镇","130434105":"车往镇","130434106":"回隆镇","130434107":"张二庄镇","130434108":"东代固镇","130434109":"院堡镇","130434201":"棘针寨乡","130434202":"沙口集乡","130434203":"野胡拐乡","130434204":"仕望集乡","130434205":"前大磨乡","130434207":"南双庙乡","130434208":"大辛庄乡","130434209":"大马村乡","130434210":"边马乡","130434212":"北台头乡","130434213":"泊口乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130434.json
// module id = 115
// module chunks = 0